<div class="container py-4">
  <section class="mb-4 d-flex align-items-start justify-content-between">
    <div>
      <div class="feedback-participant-name h4 font-weight-bold mb-0">{{ view.participantName }}</div>
      <a class="text-muted d-block mt-2" [href]="eventUrl" target="_blank" rel="noopener">{{ view.eventName }}</a>
      <div class="text-muted">{{ view.categoryName }}</div>
    </div>
    @if (totalPrograms > 1) {
      <button type="button" class="btn btn-outline-primary" (click)="toggleAll()">
        {{ (anyExpanded() ? 'viewFeedback.collapseAll' : 'viewFeedback.expandAll') | translate }}
      </button>
    }
  </section>

  @if (rounds.length === 0) {
    <div class="text-center py-5">
      <h2 class="section-heading">{{ 'viewFeedback.empty.title' | translate }}</h2>
    </div>
  }

  @for (round of rounds; track $index) {
    <div class="mb-4">
      @for (program of round.programs; track $index) {
        <div class="feedback-program sh-block overflow-hidden mb-3">
          @if (totalPrograms > 1) {
            <button
              type="button"
              class="feedback-program__header d-flex align-items-center justify-content-between w-100 bg-primary border-0 text-left text-white"
              (click)="toggleProgram(program)"
            >
              <span class="d-flex align-items-center">
                <span class="feedback-chevron text-white mr-2" [class.feedback-chevron--open]="!program.collapsed"
                  >&rsaquo;</span
                >
                <span class="font-weight-bold">{{ round.roundName }}</span>
              </span>
            </button>
          }

          @if (!program.collapsed) {
            <div class="feedback-program__body bg-white">
              @for (judge of program.judges; track judge.judgeCode) {
                <div class="feedback-section">
                  <button
                    type="button"
                    class="feedback-section__title d-flex align-items-center justify-content-between w-100 bg-info border-0 text-white"
                    (click)="toggleJudge(judge)"
                  >
                    <span class="font-weight-bold">{{ judge.judgeCode }}</span>
                    <span
                      class="feedback-section__chevron d-inline-block"
                      [class.feedback-section__chevron--collapsed]="judge.collapsed"
                      >&rsaquo;</span
                    >
                  </button>

                  @if (!judge.collapsed) {
                    @if (!judge.hasContent) {
                      <div class="stara-empty p-3 bg-white">
                        <span class="text-muted font-italic">{{ 'viewFeedback.awaitingFeedback' | translate }}</span>
                      </div>
                    } @else {
                      <div class="d-flex flex-column flex-md-row bg-white">
                        <div class="stara-elements stara-col">
                          @for (group of judge.groups; track group.id) {
                            <div class="stara-group__title px-3 py-2 font-weight-bold text-primary">{{ 'viewFeedback.stara.group.' + group.id | translate }}</div>
                            <table class="kn-table kn-table__w100 stara-group__rows">
                              <tbody>
                                @for (criterion of group.criteria; track criterion.id) {
                                  <tr class="stara-criterion">
                                    <td class="stara-criterion__label w-100">{{ 'viewFeedback.stara.element.' + criterion.id | translate }}</td>
                                    <td class="stara-criterion__grade text-primary font-weight-bold text-right text-nowrap">{{
                                      criterion.grade ? ('viewFeedback.stara.grade.' + criterion.grade | translate) : '–'
                                    }}</td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          }
                        </div>

                        <div class="stara-feedback stara-col p-3">
                          @for (block of judge.feedbacks; track block.key) {
                            <div class="stara-feedback__block mb-3">
                              <div class="stara-feedback__label font-weight-bold mb-1">{{ 'viewFeedback.feedback.' + block.key | translate }}</div>
                              @if (block.text) {
                                <span class="stara-feedback__text">{{ block.text }}</span>
                              } @else {
                                <span class="text-muted font-italic">{{
                                  'viewFeedback.awaitingFeedback' | translate
                                }}</span>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
